<template>
  <div class="home">
    <AppHeader />
    <HeroSection />
    <ProductsSection />
    <TechSection />
    <PartnershipSection />
    <AppFooter />
  </div>
</template>

<script>
import HeroSection from '@/components/HeroSection.vue'
import ProductsSection from '@/components/ProductsSection.vue'
import TechSection from '@/components/TechSection.vue'
import PartnershipSection from '@/components/PartnershipSection.vue'

import AppHeader from '../components/AppHeader.vue'
import AppFooter from '../components/AppFooter.vue'

export default {
  name: 'Home',
  components: {
    HeroSection,
    ProductsSection,
    TechSection,
    PartnershipSection,
    AppHeader,
    AppFooter
  }
}
</script>

<style scoped>

.app__body {
  padding-top: 64px;
}

@media (max-width: 768px) {
  .app__body {
    padding-top: 56px;
  }
}
</style>
